import { InjectionToken, ValueProvider } from '@angular/core';

import { Environment } from './environment.interface';

import { environment } from './environment';

/**
 * @const ENVIRONMENT
 * Injection token for the environment interface to be provided by the applications.
 */
export const ENVIRONMENT: InjectionToken<Environment> =
  new InjectionToken<Environment>('fantaz.environment');

export const getAppEnvironmentConfigProvider = (
  value?: Environment,
): ValueProvider => ({
  provide: ENVIRONMENT,
  useValue: value || environment, // by default app use the environment.ts
});
